'use strict';
import NewsletterPopup from './../homepage/newsletterPopup';
import ExternalScript from '../components/externalscripts';
// Import the multilanguage js
import Multilanguage from './../homepage/multilanguage';
import FormHelpers from '../util/form';

import {
    newModalFromString
} from '../components/modal';
import {
    createCookie, cookieExists, appendToUrl
} from './../util/common';
import WebFormRequest from './webFormRequest';
import { woosmapInitFooter } from 'woosmap';

const toggleCountrySelector = () => {
    $('.js-countryChooser').toggle();
    $('.js-languageChooser').hide();
    $('.js-languageChooserMobile').hide();
    $('.js-overlay-footer-language').show();
    $('.js-countryIconToggle').toggleClass('cc-countryIconToggle-translate');
    $('.js-languageIconToggle').removeClass('cc-countryIconToggle-translate');
    $('body').addClass('cc-footer-backgroundOverlay');
}

const toggleLanguageSelector = () => {
    $('.js-languageChooser').toggle();
    $('.js-languageChooserMobile').toggle();
    $('.js-overlay-footer-language').show();
    $('.js-countryChooser').hide();
    $('.js-languageIconToggle').toggleClass('cc-countryIconToggle-translate');
    $('.js-countryIconToggle').removeClass('cc-countryIconToggle-translate');
    $('body').addClass('cc-footer-backgroundOverlay');
}
class Footer {
    init () {
        this.registerEvents();
        this.multilanguageSubmit();
        this.newsletterForm();
        this.webFormRequest();
        this.orderStatusForm();
        this.cookieBannerHandler();
        this.cookieBannerCloseHandler();
        ExternalScript.init();
        WebFormRequest.init();
        $('#linkToBeRendered').html($('#formattedLink').text());
        this.storeLocator();
    }

    registerEvents () {
        // Inizialize the multilanguage popup
        if (cookieExists('cookie_closed') || (cookieExists('OptanonAlertBoxClosed') && cookieExists('OptanonConsent'))) {
            var condition = false;
            Multilanguage.init(condition);
            NewsletterPopup.init();
        }

        $('.submitNewsletter').on('click', function (e) {
            const newsletterEmail = $('#newsletter-Email');
            if (newsletterEmail.val() === '' || newsletterEmail.parsley().isValid()) {
                e.preventDefault();
                e.stopImmediatePropagation();
                $('#newsletterFooterForm').data('which-form', 'newsletter');
                NewsletterPopup.showPopup();
            }
        });

        $('body').on('click', function (e) {
            if (
                (!$(e.target).hasClass('js-language') &&
                    $('.js-languageChooser').css('display') == 'block') ||
                (!$(e.target).attr('id') &&
                    $('.js-languageChooserMobile').css('display') == 'block') ||
                (!$(e.target).attr('id') &&
                    $('.js-languageChooser').css('display') == 'block') ||
                (!$(e.target).attr('id') === 'country-icon-toggle-down' &&
                    $('.js-languageChooser').css('display') == 'block') ||
                (!$(e.target).attr('id') === 'country-icon-toggle-down' &&
                    $('.js-languageChooserMobile').css('display') == 'block')
            ) {
                toggleLanguageSelector();
            }
        });

        $('body').on('input', '[data-numeric-only]', function () {
            var $input = $(this);
            var cleaned = $input.val().replace(/[^0-9]/g, '');
            if ($input.val() !== cleaned) {
                $input.val(cleaned);
            }
        });

        $(document)
            .on('click', '.js-country', function (e) {
                let url = $(e.currentTarget).data('url');
                if ($('.js-countryChooser').children().length === 0) {
                    $.spinner().start();

                    $.ajax({url: url
                    }).then(function (rsp) {
                        if (rsp) {
                            $('.js-countryChooser').html(rsp);
                            toggleCountrySelector();
                            $('.submitNewsletterContacts').on('click', function (e) {
                                const newsletterEmailContacts = $('#newsletter-Email-contacts');
                                if (newsletterEmailContacts.val() === '' || newsletterEmailContacts.parsley().isValid()) {
                                    e.preventDefault();
                                    $('#newsletterFooterForm').data('which-form', 'newsletter-contacts');
                                    NewsletterPopup.showPopup();
                                }
                            });
                            $.spinner().stop();
                        }
                    });
                } else {
                    toggleCountrySelector();
                }
            })
            .on('click', '.js-overlay-footer-close', function () {
                $('.js-overlay-footer-language').hide();
            })
            .on('click', '.js-overlay-footer-language', function () {
                $('.js-countryChooser').hide();
                $('.js-overlay-footer-language').hide();
                $('.js-countryIconToggle').removeClass('cc-countryIconToggle-translate');
                $('body').removeClass('cc-footer-backgroundOverlay');
                window.scrollTo(0, document.body.scrollHeight);
            })
            .on('click', '.countryFooterClose', function () {
                $('.js-countryIconToggle').removeClass('cc-countryIconToggle-translate');
                $('.js-overlay-footer-language').hide();
                $('body').removeClass('cc-footer-backgroundOverlay');
                window.scrollTo(0, document.body.scrollHeight);
            })
            .on('click', '.js-language', function (e) {
                let url = $(e.currentTarget).data('url');
                if ($('.js-languageChooser').children().length === 0) {
                    $.spinner().start();

                    $.ajax({url: url
                    }).then(function (rsp) {
                        if (rsp) {
                            $('.js-languageChooser').html($(rsp).find('.language-selector-desktop'));
                            $('.js-languageChooserMobile').html($(rsp).find('.language-selector-mobile'));
                            toggleLanguageSelector();
                            $.spinner().stop();
                        }
                    });
                } else {
                    toggleLanguageSelector();
                }
            })
            .on('click', '.js-country-line', function (evt) {
                const $target = $(evt.currentTarget);
                if ($target.hasClass('action-change')) {
                    return;
                }
                var $clickedCheckbox = $target.find('input[type="checkbox"]');
                $('.js-country-line input[type="checkbox"]').not($clickedCheckbox).prop('checked', false);
                const url = $target.data('href');
                const locale = $target.data('locale');
                const currency = $target.data('currency');

                $.ajax({
                    url: url,
                    data: {
                        code: locale,
                        currency: currency,
                        queryString: $('.page').data('querystring'),
                        action: $('.page').data('action')
                    }
                }).then(function (rsp) {
                    if (rsp.redirectUrl) {
                        document.location.href = rsp.redirectUrl;
                    }
                });
            })
            .on('change', '.js-setLocaleCountry', function () {
                $('#setInputLocaleCountry').attr('data-locale', this.value);
            })
            .on('click', '.js-leave-feedback', function () {
                var FormId = '13864';
                KAMPYLE_ONSITE_SDK.showForm(FormId);
            })
    }

    newsletterForm () {
        lock();

        $('body').on('change', '[id="newspromotions"]', () => {
            if ($('#newspromotions').is(':checked')) {
                unlock();
                // $('#newspromotions').attr('disabled', true);
                $('#newspromotions1').attr('disabled', false);
                $('#newspromotions1').prop('checked', false);
                // $('#checkbox-label-yes').css('color', '#3C3738');
                // $('#checkbox-label-no').css('color', '#3C3738');
                $('#grayOnDisableDescription').css('color', '#3C3738');
                $('#newsPromoSpanNotTargeted').val('true');
                $('.privacy-policy-short-profiling').removeClass('disactivate');
            }
        });

        $('body').on('change', '[id="newspromotions1"]', () => {
            $('#newspromotions').prop('checked', false);
            $('#newspromotions').attr('disabled', false);
            // $('#newspromotions1').attr('disabled', true);
            lock();
            // $('#checkbox-label-yes').css('color', '#3C373880');
            // $('#checkbox-label-no').css('color', '#3C373880');
            $('#grayOnDisableDescription').css('color', '#3C373880');
            $('#newsPromoSpanNotTargeted').val('false');
            $('.privacy-policy-short-profiling').addClass('disactivate');
        });

        $('body').on('change', '[id="newspromotions_targeted"]', () => {
            if ($('#newspromotions_targeted').is(':checked')) {
                fixRequired();
                // $('#newspromotions_targeted').attr('disabled', true);
                $('#newspromotions_targeted1').attr('disabled', false);
                $('#newspromotions_targeted1').prop('checked', false);
                $('#newsPromoSpan').val('true');
            }
        });

        $('body').on('change', '[id="newspromotions_targeted1"]', () => {
            fixRequired();
            $('#newspromotions_targeted').prop('checked', false);
            $('#newspromotions_targeted').attr('disabled', false);
            // $('#newspromotions_targeted1').attr('disabled', true);
            $('#newsPromoSpan').val('false');
        });

        function lock () {
            if (!$('.lockable').hasClass('content-lock')) {
                $('.lockable').addClass('content-lock');
            }
            $('.lockable label input').attr('disabled', true);

            $('#newspromotions_targeted, #newspromotions_targeted1').prop('checked', false);
            fixRequired();
        }

        function fixRequired () {
            if ($('#newspromotions').is(':checked')) {
                if ($('#newspromotions_targeted').is(':checked') || $('#newspromotions_targeted1').is(':checked')) {
                    $('#newspromotions_targeted, #newspromotions_targeted1').prop('required', false);
                    $('.form-error').attr('style', 'display: none !important');
                } else {
                    $('#newspromotions_targeted1').prop('required', true);
                }
            } else {
                $('#newspromotions_targeted, #newspromotions_targeted1').prop('required', false);
                $('.form-error').attr('style', 'display: none !important');
            }
        }

        function unlock () {
            $('.content-lock').removeClass('content-lock');
            $('.lockable label input').attr('disabled', false);
            fixRequired();
        }

        $('body').on('submit', 'form.newsletter, form.registerNewsletter', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $.spinner().start();
            $('form.newsletter').trigger('newsletter:submit', e);
            $('body').trigger('analyticsNewsletter:submit');
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init($form, data);
                        $('form.newsletter').trigger('newsletter:error', data);
                    } else {
                        createCookie('dw_subscribepopup', '1', parseInt(window.SitePreferences.NewsletterPopupExpiryDays));
                        $('form.newsletter').trigger('newsletter:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.newsletter').trigger('newsletter:error', data);
                        $form.spinner().stop();
                    }
                }
            });
            return false;
        });
    }

    multilanguageSubmit () {
        $('body').on('submit', '.multilanguage', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        FormHelpers.init($form, data);
                    } else {
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $form.spinner().stop();
                    }
                }
            });
            return false;
        });
    }

    webFormRequest () {
        $('body').on('click', '.js-web-form-request', function (e) {
            e.preventDefault();
            // Avoid redundancy
            if ($('.page').data('action') === 'Newsletter-Contact') {
                return;
            }

            const _initWebformRequest = () => {
                var htmlContent = $('#webFormRequestModal').html();
                const modal = newModalFromString(htmlContent, false, ['web-form-request-modal']);
               
                // Make sure previous instantiations of chosen have been cleaned-up if the modal is re-opened.
                $(modal.modal).chosen('destroy');
                $(modal.modal).find($(modal.modalBox).find('.js-webFormRequest-selectFirstDropdown select')).chosen({
                    disable_search: true,
                });
                $(modal.modal).find($(modal.modalBox).find('.js-webFormRequest-selectSecondDropdown select')).chosen({
                    disable_search: true,
                });

                // Prefill user contact based on profile
                if ($('.customerFirstName') && $('.customerFirstName').length) {
                    $('.web-form-request-modal #nameformemail').val($('.customerFirstName').val());
                }
                if ($('.customerLastName') && $('.customerLastName').length) {
                    $('.web-form-request-modal #secondnameformemail').val($('.customerLastName').val());
                }
                if ($('.customerEmail') && $('.customerEmail').length) {
                    $('.web-form-request-modal #emailformemail').val($('.customerEmail').val());
                }
                // Initialize first step if the user reopen the modal without refreshing the page
                $(modal.modalBox).find('.js-webFormRequest-contactFormStepOne').removeClass('hidden');
                $('.hide-form').show();

                modal.open();
                setTimeout(() => {
                    var recaptchaSiteKey = $('#recaptchaSiteKey').val();
                    try {
                        // eslint-disable-next-line no-undef
                        grecaptcha.render('recaptcha', {
                            'sitekey': recaptchaSiteKey
                        });
                    } catch (e) {
                        $('.no-robot').removeClass('hidden');
                    }
                }, 1000);
                WebFormRequest.init(true);

                $(modal.modalBox).on('click', '.close-button', function () {
                    modal.close();
                });
            };

            if ($('#webFormRequestModal').length === 0) {
                $.ajax({
                    url: $('#webform-placeholder').data('url'),
                    type: 'GET',
                    success: function (data) {
                        $('#webform-placeholder').html(data);
                        _initWebformRequest();
                    }
                });
            } else {
                _initWebformRequest();
            }
        });
    }

    orderStatusForm () {
        var url = new URL(window.location.href);
        var showOrderStatus = url.searchParams.get('showOrderStatus');

        if (showOrderStatus) {
            const htmlContent = $('.js-modal-web-order-status-form-request').html();
            var tabContent = $('.js-content-web-order-status-form-request').html();

            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false);
            modal.open();
            modal.setContent(tabContent);
            $('.tingle-modal').addClass('wrapperModal');
            $('.tingle-modal').addClass('tingle-modal-form-request');
            $('.tingle-modal-box__content').addClass('modal-tabs-style');
            $(modal.modalBox)
                .find('.close-button')
                .on('click', function (e) {
                    modal.close();
                });

            $('.js-inside-close-modal').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
        }

        $('.js-order-status-form').on('click', function (e) {
            e.preventDefault();
            const htmlContent = $('.js-modal-web-order-status-form-request').html();
            var tabContent = $('.js-content-web-order-status-form-request').html();

            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false);
            modal.open();
            modal.setContent(tabContent);
            $('.tingle-modal').addClass('wrapperModal');
            $('.tingle-modal').addClass('tingle-modal-form-request');
            $('.tingle-modal-box__content').addClass('modal-tabs-style');
            $(modal.modalBox)
                .find('.close-button')
                .on('click', function (e) {
                    modal.close();
                });

            $('.js-inside-close-modal').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
        });

        $('body').on('click', '#form-order-status button', function (e) {
            let errors = [];
            $('#form-order-status :input:not(:button)').each(function (index, value) {
                let validator = $(this).parsley({
                    errorClass: 'is-invalid-input'
                });
                validator.validate();
                if (!validator.isValid()) {
                    errors.push(validator);
                    $('.tingle-modal-box').animate({ scrollTop: errors[0].$element[0].offsetTop }, 'slow');
                }
            });
            if (errors.length > 0) {
                e.preventDefault();
            }
        });

        $('body').on('input keyup change paste', '#ordernumberfororder', function () {
            this.value = this.value.replace(/[^0-9]/g, '');
        });
    }

    storeLocator () {
        var isWorldWebsite = $('.storeLocatorWorldFooter').length > 0;
        woosmapInitFooter(!isWorldWebsite);

        $('body').on('woosmap:chooseOptionFooter', function (_e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                const $form = $('#findStoreFooterForm');
                var coords = {
                    lat: selection.geometry.location.lat,
                    long: selection.geometry.location.lng
                };
                var updatedAction = appendToUrl($form.attr('action'), coords);

                $form.attr('action', updatedAction);
                $('.woosmap-search').val(true);
                $('form.storeLocatorFooter')[0].submit();
            }
        });
    }
    cookieBannerHandler () {
        $('body').on('click', '#onetrust-accept-btn-handler, .onetrust-close-btn-handler, #accept-recommended-btn-handler', function (e) {
            if (!cookieExists('cookie_closed')) {
                createCookie('cookie_closed', 'true', 500);
                createCookie('cookie_profiling_consent', 'true', 500);
                var condition = false;
                Multilanguage.init(condition);
                NewsletterPopup.init();
                $('.embedded-service').show();
            }
        });

        $('body').on('click', '#onetrust-accept-btn-handler', function (e) {
            createCookie('cookies-accepted', 'true', 500);
            NewsletterPopup.firstVisitNewsletterPopUp();
        });
    }

    cookieBannerCloseHandler () {
        $('body').on('click', '#onetrust-close-btn-container', function (e) {
            createCookie('cookie_profiling_consent', 'false', 500);
        });
    }
}

const footer = new Footer();
export default footer;
